import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Collapse } from "react-collapse";
import Slider from "react-slick";
import Image from "basic-elements/Image";
import PageLink from "basic-elements/PageLink";
import Hgroup from "public-components/Hgroup";
import Container from "public-components/Container";
import Sign from "public-components/Sign";
import { Store } from "public-components/StoreProvider";
import "slick-carousel/slick/slick.css";
import styles from "./WhyUsSection.module.scss";

import CircleBG from "assets/background/circle.svg";

const sliderConfig = {
  arrows: false,
  slidesToShow: 1,
  dots: true
};

const DesktopWhyUsSection = ({ data }) => {
  const [currentReason, setCurrentReason] = React.useState(data.homeWhyUsList[0].id);
  const { state, dispatch } = React.useContext(Store);
  const { userInfo, showAuthModal, signType } = state;
  React.useEffect(() => {
    dispatch({ type: "SHOW_AUTH_MODAL", showAuthModal: false });
  }, [currentReason, userInfo, dispatch]);

  const login = e => {
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      window.event.returnValue = false;
    }

    dispatch({ type: "SHOW_AUTH_MODAL", showAuthModal: true });
    dispatch({ type: "SIGNTYPE", signType: "login" });
  };

  const callback = () => {
    dispatch({ type: "SHOW_AUTH_MODAL", showAuthModal: false });
  };
  return (
    <section className={styles.whyus}>
      <CircleBG className={styles.whyus__circle} />
      <Container>
        <Hgroup className={styles.whyus__hgroup} heading={data.headingH2} />
        <div className={styles.whyus__row}>
          <div className={styles.whyus__left}>
            {data.homeWhyUsList.map(i => (
              <div className={styles.reason} key={`content-${i.id}`}>
                <h3
                  className={classnames(
                    styles.reason__heading,
                    i.id === currentReason ? styles.active : null
                  )}
                  onClick={() => setCurrentReason(i.id)}
                >
                  {i.heading}
                </h3>
                <Collapse isOpened={i.id === currentReason}>
                  <div
                    className={styles.reason__text}
                    dangerouslySetInnerHTML={{ __html: i.text }}
                  />
                  {i.linkHref || !userInfo ? (
                    <PageLink
                      className={styles.reason__button}
                      data={[
                        {
                          text: i.linkText,
                          href: i.linkHref,
                          openInNewTab: true
                        }
                      ]}
                      linkIndex={data.linkIndex}
                      currentSlug={data.currentSlug}
                      onClick={!i.linkHref && login}
                    />
                  ) : null}
                </Collapse>
              </div>
            ))}
          </div>
          <div className={styles.whyus__right}>
            {data.homeWhyUsList.map(i => (
              <div
                key={`image-${i.id}`}
                className={styles.reason__imageWrap}
                style={{ display: i.id === currentReason ? "block" : "none" }}
              >
                <Image className={styles.reason__image} data={i.image[0]} noPlaceholderClassName />
              </div>
            ))}
          </div>
        </div>
      </Container>
      {showAuthModal && <Sign authModal="loginCOM" signType={signType} callback={callback} />}
    </section>
  );
};

const MobileWhyUsSection = ({ data }) => (
  <section className={styles.whyus}>
    <Container>
      <Hgroup className={styles.whyus__hgroup} heading={data.headingH2} />
      <Slider {...sliderConfig}>
        {data.homeWhyUsList.map(i => (
          <div className={styles.reasonSlider} key={i.id}>
            <Image className={styles.reasonSlider__image} data={i.image[0]} />
            <h3 className={styles.reasonSlider__heading}>{i.heading}</h3>
            <div
              className={styles.reasonSlider__text}
              dangerouslySetInnerHTML={{ __html: i.text }}
            />
          </div>
        ))}
      </Slider>
    </Container>
  </section>
);

const WhyUsSection = ({ data }) => {
  const { state } = React.useContext(Store);
  if (state.isLargeScreen === undefined || state.isLargeScreen) {
    return <DesktopWhyUsSection data={data} />;
  }
  return <MobileWhyUsSection data={data} />;
};

WhyUsSection.propTypes = {
  data: PropTypes.shape({
    headingH2: PropTypes.string.isRequired,
    homeWhyUsList: PropTypes.arrayOf(PropTypes.object)
  }).isRequired
};

export default WhyUsSection;
